import { CloseOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Space,
} from "antd";
import React, { useState } from "react";
import { post } from "../../../apiService";
import { IoMdAdd } from "react-icons/io";

const optionsData = [
  { value: "VVS", label: "VVS" },
  { value: "VS1", label: "VS1" },
  { value: "VS2", label: "VS2" },
  { value: "SI1", label: "SI1" },
  { value: "SI2", label: "SI2" },
  { value: "SI3", label: "SI3" },
  { value: "I1", label: "I1" },
  { value: "I2", label: "I2" },
  { value: "I3", label: "I3" },
  { value: "PK", label: "PK" },
  { value: "HPK", label: "HPK" },
];

const colours = [
  {
    name: "Yellow",
    type: "HIJ",
  },
  {
    name: "Brown",
    type: "HIJ",
  },
  {
    name: "White",
    type: "FG",
  },
];

export default function AddProduct() {
  const [open, setOpen] = useState(false);
  const [addProduct] = Form.useForm();
  const [filedList, setFiledList] = useState([
    { price: null, type: null, typeColor: null, priceType: null },
  ]);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    // Append basic fields
    formData.append("avg_wt", values.avg_weight);
    formData.append("sive_sizes", values.sieve_size);
    formData.append("diam_mm", values.size_mm);
    formData.append("action", "add");
    // Create and append the price data array
    filedList.forEach((item) => {
      formData.append("priceType[]", item.priceType);
      formData.append("price[]", item.price);
      formData.append("type[]", item.type);
      formData.append("typeColor[]", item.typeColor);
    });
    // formData.append('price[]', prices);
    try {
      const response = await post("/product.php", formData);
      if (response) {
        message.success("Product added successfully");
        addProduct.resetFields();
        setFiledList([{ price: null, type: null, priceType: null }]);
        setOpen(false);
      } else {
        message.error("Product already created");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
    }
  };
  return (
    <>
      <Button
        onClick={showModal}
        style={{ background: "#003754", color: "#fff" }}
        icon={<IoMdAdd />}
      >
        Add Product
      </Button>
      <Modal
        width={600}
        title="Add Product"
        open={open}
        onOk={addProduct.submit} // Trigger form submission
        onCancel={handleCancel}
        okText="Add Product"
        okButtonProps={{
          style: { backgroundColor: "var(--primeColor)", color: "white" },
        }}
      >
        <Form
          form={addProduct}
          name="dynamic_form_complex"
          layout="vertical"
          autoComplete="off"
          onFinish={handleSubmit} // Handle form submission
        >
          <Form.Item
            label="Avg Weight"
            name="avg_weight"
            rules={[{ required: true, message: "Avg Weight is required." }]}
          >
            <Input placeholder="Avg Weight" />
          </Form.Item>
          <Form.Item
            label="Sieve Size"
            name="sieve_size"
            rules={[{ required: true, message: "Sieve Size is required." }]}
          >
            <Input placeholder="Sieve Size" />
          </Form.Item>
          <Form.Item
            label="Size (mm)"
            name="size_mm"
            rules={[{ required: true, message: "Size is required." }]}
          >
            <Input placeholder="Size (mm)" />
          </Form.Item>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              rowGap: 16,
            }}
          >
            {filedList.map((valueAgain, index) => (
              <div className="row" key={index}>
                <div className="col-md-2 col-6 mb-3 mb-md-0">
                  <InputNumber
                    prefix="$"
                    style={{ minHeight: "30px", width: "100%" }}
                    placeholder="Price"
                    value={valueAgain.price || ""}
                    onChange={(v) =>
                      setFiledList((prev) => {
                        const newData = [...prev];
                        newData[index].price = v;
                        return newData;
                      })
                    }
                  />
                </div>
                <div className="col-md-2 col-6">
                  <Select
                    placeholder="Type"
                    options={[
                      { value: "FG", label: "FG" },
                      { value: "HIJ", label: "HIJ" },
                    ]}
                    value={valueAgain.type || null}
                    onChange={(v) =>
                      setFiledList((prev) => {
                        const newData = [...prev];
                        newData[index].type = v;
                        newData[index].typeColor = null;
                        newData[index].priceType = null;
                        return newData;
                      })
                    }
                    style={{ minWidth: "100%" }}
                  />
                </div>
                <div className="col-md-3 col-6">
                  <Select
                    value={valueAgain.typeColor || null}
                    placeholder="Select Colour"
                    style={{ width: "100%" }}
                    options={colours
                      .filter((val) => val.type === valueAgain.type)
                      .map((value) => ({
                        label: value.name,
                        value: value.name,
                      }))}
                    onChange={(v) =>
                      setFiledList((prev) => {
                        const newData = [...prev];
                        newData[index].typeColor = v;
                        newData[index].priceType = null;
                        return newData;
                      })
                    }
                  />
                </div>
                <div className="col-md-3 col-6">
                  <Select
                    placeholder="Price Type"
                    value={valueAgain.priceType || null}
                    onChange={(v) =>
                      setFiledList((prev) => {
                        const newData = [...prev];
                        newData[index].priceType = v;
                        return newData;
                      })
                    }
                    style={{ width: "100%" }}
                  >
                    {optionsData
                      .filter(
                        (valueData) =>
                          !filedList.some(
                            (val) =>
                              val.priceType === valueData.value &&
                              val.type === valueAgain.type
                          )
                      )
                      .map((valueData) => (
                        <Select.Option
                          key={valueData.value}
                          value={valueData.value}
                          label={valueData.label}
                        >
                          {valueData.label}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
                <div className="col-md-1">
                  {filedList.length > 1 && (
                    <CloseOutlined
                      className="text-danger"
                      onClick={() =>
                        setFiledList((prev) => {
                          const updatedList = [...prev];
                          updatedList.splice(index, 1);
                          return updatedList;
                        })
                      }
                    />
                  )}
                </div>
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() =>
                setFiledList((prev) => [
                  ...prev,
                  { price: null, type: null, priceType: null },
                ])
              }
              block
            >
              + Add Sub Item
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
